import { PromotionsService } from '../services';
import { usePromotionPayoutsQuery } from './usePromotionPayoutsQuery';

export const getPromotionPayoutsQueryKey = (promotionId) => [
  'GET_PROMOTION_PAYOUTS',
  promotionId,
];

// Only fetch a promotion's batches when its row is expanded.
export const useGetPromotionPayouts = (promotionId, options) =>
  usePromotionPayoutsQuery(
    getPromotionPayoutsQueryKey(promotionId),
    () => PromotionsService.getPromotionPayouts(promotionId),
    { enabled: options?.enabled ?? !!promotionId },
  );
